import { render } from "./UiCardBody.vue?vue&type=template&id=512c0226"
import script from "./UiCardBody.vue?vue&type=script&lang=js"
export * from "./UiCardBody.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__